// extracted by css-extract-rspack-plugin
export default {"cls1":"SourceText-cls1_Y19","cls2":"SourceText-cls2_zv6 SourceText-cls1_Y19"};